import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TableComponent = ({ tableHead, tableBody, bodyCells, customStyle, clickHandler, bodyCellsCustomColor={}, bodyCellsCustomSymbol={} }) => {
    const tableHeadCell = tableHead || [];
    const tableBodyCell = tableBody || [];
    const tableBodyCells = bodyCells || [];

  const reformatDate = (dateString) => {
    const date = new Date(dateString);

    // Get the Date part: "Dec 23, 2025"
    const datePart = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    // Get the Time part: "9:21 PM"
    const timePart = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    // Combine and replace the comma after the day with your bullet point
    return `${datePart.replace(',', ' •')} ${timePart}`;
  };


    // function to return table cell value
  const getTableCell = (row, item) => {
    if (item === 'date' || item === 'dispensed_at' || item === 'processed_at') {
      return reformatDate(row[item])
    } else if (typeof row[item] === 'boolean') {
      return row[item] ? 'Yes' : 'No'
    } else {
      if (row[item]) {
        return row[item]
      } else {
        return '-'
      }
    }
  }
  
    return (
      <TableContainer sx={customStyle && customStyle.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {tableHeadCell.map((cell, i) => (
                <TableCell key={i} sx={customStyle && (typeof customStyle.headerTableCell === 'function'
                  ? customStyle.headerTableCell(cell)
                  : customStyle.headerTableCell)}>{cell}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableBodyCell.map((row, j) => (
              <TableRow
                key={j}
                sx={{
                  ...customStyle?.row,
                  "&:nth-of-type(odd)": { backgroundColor: "#fff" },
                  "&:nth-of-type(even)": { backgroundColor: "#f5f5f5" },
                }}
                onClick={() => clickHandler && clickHandler(row)}
              >
                {tableBodyCells.map((item, j) => (
                  <TableCell
                    key={j}
                    sx={[
                      { color: bodyCellsCustomColor[item] },
                      customStyle && customStyle.tableCell,
                    ]}
                  >
                    {bodyCellsCustomSymbol[item] && bodyCellsCustomSymbol[item]}
                    {item === "product_package_size"
                      ? Number(getTableCell(row, item))
                      : getTableCell(row, item)}
                  </TableCell>
                ))}
              </TableRow>
            ))}

          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  
  export default TableComponent;

 /*
Usage:

1. Define your data:
   const sampleData = [
     { name: 'John', number: 123 },
     { name: 'Alex', number: 456 },
   ]

2. Call the TableComponent in your Component:
   <TableComponent
     tableHead={['Name', 'Number']}
     tableBody={sampleData}
     bodyCells={['name', 'number']}
   />

3. Explanation of Props:
   - `tableHead`: An array representing the header cells of the table. Example: ['Name', 'Number'].
   - `tableBody`: An array of objects, where each object represents a row in the table. Example: sampleData.
   - `bodyCells`: An array of strings representing the keys of the objects to display in each row. Example: ['name', 'number'].

Resulting Table Content:
   Name  Number
   John  123
   Alex  456
*/